/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAssetLogRequestDto
 */
export interface UpdateAssetLogRequestDto {
    /**
     * Updated received timestamp stored in context.receivedAt
     * @type {Date}
     * @memberof UpdateAssetLogRequestDto
     */
    receivedAt: Date;
    /**
     * Editable raw log content stored exactly as entered.
     * @type {string}
     * @memberof UpdateAssetLogRequestDto
     */
    rawLog: string;
}

/**
 * Check if a given object implements the UpdateAssetLogRequestDto interface.
 */
export function instanceOfUpdateAssetLogRequestDto(value: object): value is UpdateAssetLogRequestDto {
    if (!('receivedAt' in value) || value['receivedAt'] === undefined) return false;
    if (!('rawLog' in value) || value['rawLog'] === undefined) return false;
    return true;
}

export function UpdateAssetLogRequestDtoFromJSON(json: any): UpdateAssetLogRequestDto {
    return UpdateAssetLogRequestDtoFromJSONTyped(json, false);
}

export function UpdateAssetLogRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAssetLogRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'receivedAt': (new Date(json['receivedAt'])),
        'rawLog': json['rawLog'],
    };
}

export function UpdateAssetLogRequestDtoToJSON(json: any): UpdateAssetLogRequestDto {
    return UpdateAssetLogRequestDtoToJSONTyped(json, false);
}

export function UpdateAssetLogRequestDtoToJSONTyped(value?: UpdateAssetLogRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'receivedAt': value['receivedAt'].toISOString(),
        'rawLog': value['rawLog'],
    };
}

